export default {
  es: {
    COURSE_PACK_TITLE: `Elige tus cursos`,
    CLEAN_FILTERS: 'Limpiar filtros',
    BANNER_COURSE_PACK_CLEAN: 'Limpiar selección',
    BANNER_COURSE_PACK_RECOMMENDATION: 'Recomiéndame cursos',
    COURSE_BANNER_PACK_BUTTON: 'Llévatelos por',
  },
};
